import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { campaignsFeatureKey } from '../store/campaigns/campaigns.reducer';
import * as CampaignsActions from '../store/campaigns/campaigns.actions';
import * as fromRoot from '../store/app.reducer';

@Injectable({
  providedIn: 'root',
})
export class CampaignsResolver {
  constructor(private store: Store<fromRoot.AppState>) { }

  resolve(): Observable<any> {
    return this.store.select(campaignsFeatureKey).pipe(
      take(1),
      switchMap((campaignState) => {
        if (campaignState.campaigns && campaignState.campaigns.length > 0) {
          // Return cached data if available
          return of(campaignState.campaigns);
        } else {
          // Dispatch action to fetch campaigns if not in cache
          this.store.dispatch(CampaignsActions.getCampaigns());
          return this.store.select(campaignsFeatureKey).pipe(
            filter((state) => !state.isLoading),
            take(1),
            map((state) => state.campaigns),
            catchError((error) => {
              console.error('Error resolving campaigns:', error);
              return of([]);
            })
          );
        }
      })
    );
  }
}
